import { render, staticRenderFns } from "./exp404.vue?vue&type=template&id=0fc0bd86&scoped=true"
import script from "./exp404.vue?vue&type=script&lang=js"
export * from "./exp404.vue?vue&type=script&lang=js"
import style0 from "./exp404.vue?vue&type=style&index=0&id=0fc0bd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0bd86",
  null
  
)

export default component.exports